import React from "react";

import {
  faCheckCircle,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { get } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";

import { setSetting } from "actions";

import { FaIcon } from "components/AgGridButtonIcon/agGridButtonIcon";
import Clickable from "components/Button/Clickable";
import { Row } from "components/Layout";

import { AttachmentSearchFields } from "constants/attachmentSearch";
import { NVDRelatedDocumentTypes } from "constants/documentTypes";
import { Settings } from "constants/settings";

import { openAttachments } from "lib/navigation";

import { selectAgencyIdByDeploymentSaleIdLookup } from "selectors/agencies";

const WrapperImage = styled.div`
  position: relative;
  overflow-y: hidden;
  display: flex;
  flex-direction: row;
  height: 24px;
`;

const plusMore = value =>
  value.length > 1 && <span>&nbsp; +{value.length - 1}</span>;

export function DeclarationAttachmentsRenderer(params) {
  const dispatch = useDispatch();
  const agencyIdByDeploymentSaleId = useSelector(
    selectAgencyIdByDeploymentSaleIdLookup,
  );

  if (!params.data) {
    return null;
  }
  const value = get(params.data, params.colDef.field) || [];

  const declarationAttachments = value.filter(a =>
    NVDRelatedDocumentTypes.includes(a.type),
  );

  if (declarationAttachments.length > 0) {
    const attachment = declarationAttachments[0];

    const src = attachment.thumbnail_url || attachment.image_url;

    const handleClick = () => {
      const agencyId = agencyIdByDeploymentSaleId[attachment.deploymentSale];
      if (agencyId) {
        dispatch(setSetting(Settings.agencyId, agencyId));
      }
      dispatch(
        setSetting(Settings.attachmentSearch, {
          [AttachmentSearchFields.Consignment]: [attachment.consignment],
        }),
      );
      if (attachment.isCompleted) {
        dispatch(setSetting(Settings.selectedAttachmentId, attachment.id));
      }
      openAttachments();
    };

    if (attachment.isCompleted === true) {
      return (
        <Clickable
          onClick={handleClick}
          key={`attachment-${attachment.consignment}`}
        >
          <Row>
            <WrapperImage>
              <FaIcon icon={faCheckCircle} color="success" />
              <img alt="consignmentAttachment" height={36} src={src} />
            </WrapperImage>
            {plusMore(declarationAttachments)}
          </Row>
        </Clickable>
      );
    } else {
      return (
        <Clickable
          onClick={handleClick}
          key={`attachment-${attachment.consignment}`}
        >
          <Row>
            <WrapperImage>
              <FaIcon icon={faExclamationCircle} color="warning" />
              <img alt="consignmentAttachment" height={36} src={src} />
            </WrapperImage>
            {plusMore(declarationAttachments)}
          </Row>
        </Clickable>
      );
    }
  } else {
    return <FaIcon icon={faExclamationCircle} color="warning" />;
  }
}

export function imageAttachmentsRenderer(props) {
  const { data } = props;
  if (!data) {
    return null;
  }
  const value = data.attachments || [];

  if (value.length > 0) {
    return (
      <WrapperImage>
        <img alt="saleLotImage" src={value[0].thumbnail_url} />
        {plusMore(value)}
      </WrapperImage>
    );
  } else {
    return null;
  }
}
